import * as React from 'react'
import { Helmet } from 'react-helmet'

import { ThemeProvider } from '@mui/material'
import ioTheme from '../theme'

import { Link as GatsbyLink } from 'gatsby'

import { Container, Typography, Box, Card, CardContent, CardActions, Button, IconButton, Grid } from '@mui/material'
import Masonry from '@mui/lab/Masonry';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import HeroNew from '../components/HeroNew'

import Header from '../sections/Header'
import Footer from '../sections/Footer'

import '../style/style.css'

const TITLE = 'IO: News'

export default function App() {
    
    return (
        <div id='Top' className='App'>
            <Helmet>
                <link rel="icon" type="image/png" href="/favicon.png" sizes="16x16" />
                <title>{ TITLE }</title>
                <meta name='description' content="Stay up to date with news covering all of Impact Observatory's innovative products and ideas!" />
            </Helmet>

            <ThemeProvider theme={ioTheme}>

                <Header />

                <HeroNew
                    title='News'
                    subtitle='Stay up to date with news covering all of IO&#39;s innovative products and ideas!'
                    image={'/images/news_hero.jpg'}/>

                <Container>
                    <Typography gutterBottom variant='h4' component='h2' align='center'>Featured Items</Typography>
                    <Box sx={{mb:6, pr:2}}>
                        <GatsbyLink to='https://www.planet.com/pulse/impact-observatory-leverages-planet-data-and-ai-to-deliver-insights-to-u-s-local-and-national-government/' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Planet Pulse</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>
                                        Impact Observatory Leverages Planet Data and AI to Deliver Insights to U.S. Local and National Government
                                    </Typography>
                                    <Typography variant='body2' component='p'>
                                        Traditionally, identifying patterns of change on land has been expensive, complex, and labor-intensive, making it difficult to scale to the vast amount of available satellite imagery. To address this challenge, Planet partner Impact Observatory has developed AI-powered geospatial monitoring tools that help decision-makers understand risks and anticipate changes at unprecedented speed and scale
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <CardActions>
                                        <Button variant='text' size='small'>Read Article</Button>
                                    </CardActions>
                                </CardActions>
                            </Card>
                        </GatsbyLink>
                    </Box>

                    
                    <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={2}>
                        <GatsbyLink to='https://www.esri.com/arcgis-blog/products/arcgis-living-atlas/imagery/global-land-cover-updates-2/' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>ArcGIS Blog</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>
                                        Global Land Cover Updates
                                    </Typography>
                                    <Typography variant='body2' component='p'>
                                        Annual 10-meter global coverage from 2017-2023.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <CardActions>
                                        <Button variant='text' size='small'>Read Article</Button>
                                    </CardActions>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='../news/general-availability-press-release' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>IO Press Release</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>Impact Observatory Announces the General Availability of IO Monitor to Deliver AI-Powered Global Space-based High Resolution Living Land Cover Land Maps</Typography>
                                    <Typography variant='body2' component='p'>IO Monitor Enables Customers to Understand Climate, Financial, and Environmental Risk in Near Real-time and at Previously Unobtainable Speed and Scale.</Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='https://www.upstream.tech/webinars/exploring-custom-land-use-land-cover-maps-for-monitoring-change#video' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Upstream Tech</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>Exploring Custom Land Use & Land Cover Maps for Monitoring Change</Typography>
                                    <Typography variant='body2' component='p'>Join us for a session introducing Custom Land Use Land Cover (LULC) change maps from Impact Observatory, which enable decision makers to understand risks and anticipate change in near-real-time.</Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='https://open.spotify.com/episode/7gvtHsgwBOqrR1sEan9RBR?si=a806c7aef2ad482f' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Minds Behind Maps</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>Steve Brumby: Governments Need Better Maps, Impact Observatory, Descartes Labs & National Geographic</Typography>
                                    <Typography variant='body2' component='p'>Steve Brumby is the founder & CTO of Impact Observatory, a company working on providing rapid land cover maps anywhere on Earth. He puts it as wanting to provide "the maps the US takes for granted, all around the globe". Steve was also a co-founder & the CTO at Descartes Labs and worked at National Geographic.</Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='../news/planet-partner-press-release' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>IO Press Release</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>AI-Powered Impact Observatory Announces Partnership with Planet to Deliver Near Real-Time Change Monitoring with Best-in-Market Accuracy, Frequency and Resolution</Typography>
                                    <Typography variant='body2' component='p'>Collaboration leverages PlanetScope Imagery Data to help customers better understand our changing world and make critical decisions faster.</Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='https://www.bizjournals.com/washington/inno/stories/news/2023/03/29/impact-observatory-ai-dc-satellite-mapping-funding.html?csrc=6398&taid=642439d71e537d0001849a18&utm_campaign=trueAnthemTrendingContent&utm_medium=trueAnthem&utm_source=twitter' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Washington Business Journal</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>AI satellite mapping startup Impact Observatory raises funding in D.C.</Typography>
                                    <Typography variant='body2' component='p'>
                                        D.C. geospatial mapping company Impact Observatory, which uses artificial intelligence and satellite imagery to power its technology, has raised a nearly $6 million seed round to bring its product to market — and multiply in size.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>
                        
                        
                        <GatsbyLink to='https://www.esri.com/about/newsroom/announcements/esri-releases-latest-land-cover-map-with-improved-ai-modeling/' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Esri</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>Esri Releases Latest Land Cover Map with Improved AI Modeling</Typography>
                                    <Typography variant='body2' component='p'>
                                        2017–2022 High-Resolution Maps in Esri’s ArcGIS Living Atlas of the World are Now More Temporally Consistent
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='https://www.axios.com/2023/03/07/golden-age-earth-observation' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Axios</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>The golden age of Earth observation is here</Typography>
                                    <Typography variant='body2' component='p'>
                                        From monitoring deforestation in real time to tracking greenhouse gas emissions and fact-checking claims made during wars, satellite data is providing an unprecedented view of what's happening on the ground each day.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>
                        
                        {/* <GatsbyLink to='https://insidegnss.com/more-data-in-more-hands-will-aid-in-fighting-climate-change-speakers-say/' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>Inside GNSS</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>More Data in More Hands will Aid in Fighting Climate Change, Speakers Say</Typography>
                                    <Typography variant='body2' component='p'>
                                    In the wake of the latest COP session on international climate change, and as the world continues to deal with the effects of a warming planet, researchers say more and better data can help ameliorate the damage and provide answers on how to respond to it.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>
 
                        <GatsbyLink to='https://www.washingtonpost.com/weather/2022/02/18/environmental-intelligence-extreme-weather-climate/' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>The Washington Post</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>How a booming ‘environmental intelligence’ sector is confronting extreme weather and climate change.</Typography>
                                    <Typography variant='body2' component='p'>
                                    A long-embraced vision of the federal Earth science leadership is that the private sector will create innovative and game-changing products resulting from the nation’s investment in robust and sustained Earth science and observations. Today, that vision is in clear view. It couldn’t come at a more critical time.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink>


                        <GatsbyLink to='https://www.nytimes.com/2022/09/11/world/asia/pakistan-floods-food-crisis.html' target='_blank' style={{textDecoration:'none'}}>
                            <Card variant='clickable'>
                                <CardContent>
                                    <Typography variant='subtitle2' component='p' color='text.secondary'>The New York Times</Typography>
                                    <Typography gutterBottom variant='h6' component='h3'>"Very Dire": Devastated by Floods, Pakistan Faces Looming Food Crisis</Typography>
                                    <Typography variant='body2' component='p'>
                                        The flooding has crippled Pakistan’s agricultural sector, battering the country as it reels from an economic crisis 
                                        and double-digit inflation that has sent the price of basics soaring.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <IconButton aria-label='external-link' size='small' color='primary'>
                                        <ExitToAppIcon fontSize='medium' />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </GatsbyLink> */}
                    </Masonry>
                </Container>

                <Container>
                    <Typography gutterBottom variant='h4' component='h2' align='center'>Additional Items</Typography>
                    <Grid container spacing={3} justifyContent='center' alignItems='flex-end'>
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.bizjournals.com/washington/inno/stories/awards/2024/03/14/impact-observatory.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>The Business Journal</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2024</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Startup to Watch: Impact Observatory</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.skyfi.com/blog/skyfi-and-impact-observatory' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>SkyFi</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>September 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>SkyFi and Impact Observatory: Opening Access to Land Monitoring</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.nga.mil/news/AI_Revolutionizes_Mapping_Updates_and_Accuracy.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>NGA</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>July 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>AI revolutionizes mapping updates and accuracy</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.ivoox.com/41-8220-provably-green-8221-with-data-and-ai-audios-mp3_rf_112267246_1.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>PromptPod</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>July 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>#41. “Provably Green” with Data and AI</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.energymonitor.ai/tech/digitalisation/chatgpt-deus-ex-machina-for-the-energy-transition/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Energy Monitor</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>June 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>ChatGPT: Deus ex machina for the energy transition?</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://pulse2.com/impact-observatory-steve-brumby-profile/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Pulse 2.0</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>June 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Impact Observatory: This Company Offers High-Quality Geospatial Tools In A $100 Billion Market</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.nga.mil/news/AI_Revolutionizes_Mapping_Updates_and_Accuracy.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>National Geospatial-Intelligence Agency</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>May 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>AI revolutionizes mapping updates, accuracy</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://spacenews.com/impact-observatory-unveils-io-monitor/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Space News</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>May 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Impact Observatory unveils IO Monitor</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='../news/early-access-press-release' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>IO Press Release</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>May 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Impact Observatory Launches IO Monitor to Understand Climate, Financial, and Environmental Risk in Near Real-Time</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://medium.com/vizzuality-blog/new-biodiversity-intactness-data-for-conservation-planning-and-evaluation-104dcd679e4' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Vizzuality Blog</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>May 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>New biodiversity intactness data for conservation planning and evaluation</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://techcrunch.com/2023/04/03/max-q-the-starliners-are-not-aligned/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>TechCrunch</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>April 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Max Q: The Starliners are not aligned</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.cnbc.com/2023/03/30/investing-in-space-boeings-got-to-get-going.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>CNBC</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Investing in Space: Boeing’s got to get going</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://technical.ly/startups/impact-observatory-seed-raise-ai-space-mapping/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Technical.ly DC</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>DC mapping company Impact Observatory just raised a $5.9M seed round</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://spacenews.com/impact-observatory-raises-5-9-million-to-apply-ai-to-satellite-imagery/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>SpaceNews</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Impact Observatory raises $5.9 million to apply AI to satellite imagery</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://nymag.com/article/2023/03/comments-week-of-march-13-2023.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>New York Magazine</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>“You Are Not a ­Parrot”</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                    
                    
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='../news/seed-round-press-release' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>IO Press Release</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Impact Observatory Secures $5.9M Seed Round to Bring AI-powered Space-based Monitoring for Sustainability, Climate, and Environmental Risk</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.axios.com/2023/02/07/climate-change-satellites' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Axios</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>February 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Data from satellites is starting to spur climate action</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        {/* insidegnns */}
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://moderndiplomacy.eu/2022/10/11/un-biodiversity-lab-sets-out-on-a-data-mission-to-protect-people-and-planet/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Inside GNSS</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>December 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>More Data in More Hands will Aid in Fighting Climate Change, Speakers Say</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://moderndiplomacy.eu/2022/10/11/un-biodiversity-lab-sets-out-on-a-data-mission-to-protect-people-and-planet/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Modern Diplomacy</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>October 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>UN Biodiversity Lab sets out on a data mission to protect people and planet</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        {/* new york times */}
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.nytimes.com/2022/09/11/world/asia/pakistan-floods-food-crisis.html' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>The New York Times</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>September 2023</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>"Very Dire": Devastated by Floods, Pakistan Faces Looming Food Crisis</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.scientificamerican.com/article/nasa-rsquo-s-ufo-study-isn-rsquo-t-really-looking-for-space-aliens/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Scientific American</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>August 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>NASA’s UFO Study Isn’t Really Looking for Space Aliens</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://themiltonpartnership.com/wp-content/uploads/2022/08/The-Difference-5.pdf' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>The Difference by The Milton Partnership</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>August 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>The Difference</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>    
                            <GatsbyLink to='https://medium.com/impactobservatoryinc/mapping-the-world-with-unmatched-frequency-54a83527f138' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>IO Medium</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>"Mapping the world with unmatched frequency"</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        
                                                
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.fastcompany.com/90729824/these-maps-from-satellite-data-show-how-much-earth-has-changed-in-only-five-years' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Fast Company</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>March 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>These maps from satellite data show how much Earth has changed in only five years.</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>

                        {/* update washington post */}
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.washingtonpost.com/weather/2022/02/18/environmental-intelligence-extreme-weather-climate/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>The Washington Post</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>February 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>How a booming ‘environmental intelligence’ sector is confronting extreme weather and climate change.</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://customers.microsoft.com/en-us/story/1459632165188903952-impact-observatory-professional-services-azure-hpc' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Microsoft Customer Story</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>January 2022</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Using AI to Map a Better Future</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.nationalgeographic.com/magazine/graphics/tracking-the-great-serengeti-wildebeest-migration-feature' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>National Geographic Magazine Feature</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>November 2021</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Tracking the Great Serengeti Wildebeest Migration</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://moderndiplomacy.eu/2021/11/27/how-digital-technology-and-innovation-can-help-protect-the-planet/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Modern Diplomacy</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>November 2021</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>How digital technology and innovation can help protect the planet</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>


                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://lidarmag.com/2021/11/08/esri-imagery-summit-in-redlands/' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>LIDAR Magazine</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>November 2021</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>Esri Imagery Summit in Redlands</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        

                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.bbc.com/news/science-environment-57615408' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>BBC</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>June 2021</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>"'Eyes of a machine': How to classify Planet Earth"</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                        

                        {/* <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://storymaps.arcgis.com/stories/486cd2ae2016454f951c97f802f125b3?adumkts=product&aduc=social&adum=external&aduSF=twitter&utm_Source=social&aduca=mi_arcgis_storymaps_awareness&aduco=video&adulb=multiple&adusn=multiple&aduat=storymap&adupt=awareness&sf_id=701f2000001C36aAAC' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Typography variant='subtitle2' component='p' color='text.secondary'>ESRI Blog Post</Typography>
                                        <Typography gutterBottom variant='h6' component='h3'>A New Land Cover Map of the World</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid> */}

                        

                        
                        <Grid item xs={12} md={10}>
                            <GatsbyLink to='https://www.podbean.com/ew/pb-u27xf-1112e34' target='_blank' style={{textDecoration:'none'}}>
                                <Card variant='clickable'>
                                    <CardContent>
                                        <Grid container justifyContent='space-between' direction='row'>
                                            <Grid item>        
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>Podcast Episode</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' component='p' color='text.secondary'>October 2021</Typography>
                                            </Grid>
                                        </Grid>
                                        <Typography gutterBottom variant='h6' component='h3'>The Scene from Above Podcast</Typography>
                                    </CardContent>
                                </Card>
                            </GatsbyLink>
                        </Grid>
                    </Grid>
                </Container>



                <Footer />
            </ThemeProvider>
        </div>
    );
}
